"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "13", height: "10", viewBox: "0 0 13 10", className: "Icon board-link", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement("path", { d: "M8.125 3.283c-3.819 0-7.15 2.626-8.076 6.369L0 9.848a11.051 11.051 0 0 1 7.849-3.282h.276v3.282L13 4.924 8.125 0v3.283z", fill: "#FFF", fillRule: "nonzero" })
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/board-link.js
// module id = 1785
// module chunks = 0